/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Event_Gap_LabelInputs */



/**
* | output |
* | --- |
* | "Event Gap" |
*
* @param {Style_Guide_Manager_Event_Gap_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_event_gap_label = /** @type {((inputs?: Style_Guide_Manager_Event_Gap_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Event_Gap_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ecart d'evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignislücke")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gap dell'evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Разрыв событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Brecha de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件间隙")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントギャップ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("घटना अंतराल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Lacuna de Eventos")
	return /** @type {LocalizedString} */ ("Event Gap")
});